angular
    .module('empower.control', ['control.searchDropdown']);